import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface TaxAlertProps {
  isTaxCompliant: boolean | null;
  hasPendingStipends: boolean;
}

export const TaxAlert = ({
  isTaxCompliant,
  hasPendingStipends,
}: TaxAlertProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (isTaxCompliant !== false) return null;

  return (
    <Alert variant={hasPendingStipends ? "destructive" : "warning"}>
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex md:flex-1 flex-row items-center gap-4">
          <Info className="h-5 w-5" />
          <AlertDescription
            className="flex-1 font-bold"
            data-test-id="tax-alert-description"
          >
            {hasPendingStipends
              ? t("tax_required_msg")
              : t("tax_requiresTaxInfo")}
          </AlertDescription>
        </div>

        <Button
          data-test-id="tax-alert-button"
          size="sm"
          onClick={() => navigate("/tax")}
          variant="outline"
        >
          {t("findOutMore")}
        </Button>
      </div>
    </Alert>
  );
};
